// extracted by mini-css-extract-plugin
export default {"smallBanner":"miniheader_smallBanner__DfvNh","ptag":"miniheader_ptag__iQ9Vb","move-rtl":"miniheader_move-rtl__ttqXa"};